import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Zap, Activity, Shield, Calendar, Clock } from 'lucide-react';
export function FeaturesSection() {
  const features = [{
    icon: <Clock className="w-5 h-5 text-teal-600" data-id="element-16" />,
    title: 'The 12-Minute R³ Routine',
    desc: 'Step-by-step daily protocol that fits into your morning or evening.'
  }, {
    icon: <Zap className="w-5 h-5 text-amber-500" data-id="element-17" />,
    title: '5 Ultra-Fast Regulation Switches',
    desc: '2-minute tools to use in the bathroom, car, or at your desk.'
  }, {
    icon: <Activity className="w-5 h-5 text-indigo-500" data-id="element-18" />,
    title: '5-Minute Release Practices',
    desc: 'No equipment needed. Just simple ways to drop the physical armor.'
  }, {
    icon: <BookOpen className="w-5 h-5 text-rose-500" data-id="element-19" />,
    title: 'Rebuild Tools',
    desc: 'Practices for calm + control that actually stick.'
  }, {
    icon: <Calendar className="w-5 h-5 text-blue-500" data-id="element-20" />,
    title: 'Full 14-Day Plan + Trackers',
    desc: 'Know exactly what to do each day. No decision fatigue.'
  }, {
    icon: <Shield className="w-5 h-5 text-emerald-500" data-id="element-21" />,
    title: 'The Relapse Plan',
    desc: 'A specific protocol for when you fall off the wagon (because you will).'
  }];
  return <section className="py-24 px-6 bg-[#faf9f7]" data-id="element-22">
      <div className="max-w-5xl mx-auto" data-id="element-23">
        <div className="text-center mb-16" data-id="element-24">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-25">
            What’s inside the reset
          </h2>
          <p className="text-slate-600" data-id="element-26">
            Everything you need to build a new baseline.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-27">
          {features.map((feature, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white p-6 rounded-xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-28">
              <div className="w-10 h-10 rounded-full bg-slate-50 flex items-center justify-center mb-4" data-id="element-29">
                {feature.icon}
              </div>
              <h3 className="font-bold text-slate-900 mb-2" data-id="element-30">{feature.title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed" data-id="element-31">
                {feature.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}